export const engagementApiSegmentCohortsTags = "/engagement/api/segment_cohorts/tags";
